/* eslint no-use-before-define: 0 */
import React, { Component } from 'react';
import { Translation } from 'react-i18next';

import MultiSelectUser from 'components/site/multi-user-search';

export default class CustomerMultiSearchFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      customers: [],
      filterItems: [],
    };
  }

  getModel() {
    const { filterItems } = this.state;
    return { value: filterItems };
  }

  setModel(model) {
    const filterItems = (model ? model.value : []) ?? [];
    this.setState({
      filterItems,
      customers: filterItems.map((item) => ({
        name: item[this.props.column.colId],
      })),
    });
  }

  handleCustomerSelected = (newCustomer) => {
    const { customers, filterItems } = this.state;
    // Build new array references (don't mutate in place) so getModel() returns
    // a distinct array each change — otherwise the previously stored grid filter
    // model shares the same array and isEqual() treats the change as a no-op,
    // suppressing the refetch when a second customer is added.
    const newCustomers = [...customers, newCustomer];
    const newFilterItems = [
      ...filterItems,
      {
        [this.props.column.colId]: newCustomer._id,
        name: newCustomer?.name,
      },
    ];
    this.setState(
      { customers: newCustomers, filterItems: newFilterItems },
      () => {
        this.props.filterChangedCallback();
      },
    );
  };

  handleCustomerRemoved = (removedCustomer) => {
    const { customers, filterItems } = this.state;
    const newCustomers = customers.filter(
      (c) => c.name !== removedCustomer.name,
    );
    const newFilterItems = filterItems.filter(
      (f) => f[this.props.column.colId] !== removedCustomer._id,
    );
    this.setState(
      { customers: newCustomers, filterItems: newFilterItems },
      () => {
        this.props.filterChangedCallback();
      },
    );
  };

  doesFilterPass(params) {
    if (this.props.isUsedInMultifilter) {
      // filtering order is not defined when using multifilter
      // so could not use doesRowPassOtherFilter here
      return true;
    }

    const { filterItems } = this.state;

    const filterValues = filterItems.map((item) =>
      (item[this.props.column.colId] || '').toLowerCase(),
    );

    const columnValue =
      params.node.data[this.props.column.colId].toLowerCase() || '';

    return (
      filterValues.filter((match) => {
        return columnValue.includes(match);
      }).length > 0
    );
  }

  isFilterActive() {
    return (this.state.filterItems || []).length > 0;
  }

  afterGuiAttached() {
    this.focus();
  }

  focus() {
    window.setTimeout(() => {
      const container = this.props.reactContainer;
      if (container) {
        container.focus();
      }
    });
  }

  getFilterSlugs(column) {
    switch (column) {
      case 'shipper_name':
        return { labelSlug: 'SHIPPER', placeholderSlug: 'SEARCH_FOR_SHIPPER' };
      case 'carrier':
        return { labelSlug: 'CARRIER', placeholderSlug: 'SEARCH_FOR_CARRIER' };
      default:
        return {
          labelSlug: 'CUSTOMER',
          placeholderSlug: 'SEARCH_FOR_CUSTOMER',
        };
    }
  }

  getCustomerSearchType(column) {
    switch (column) {
      case 'shipper_name':
        return 'shippers';
      case 'carrier':
        return 'carriers';
      default:
        return 'customers';
    }
  }

  render() {
    const filterSlugs = this.getFilterSlugs(this.props.column.colId);
    const customerSearchType = this.getCustomerSearchType(
      this.props.column.colId,
    );
    return (
      <div className="p-1">
        <Translation>
          {(t) => (
            <>
              <label className="mb-0.5 form-label">
                {t(filterSlugs.labelSlug)}
              </label>
              <MultiSelectUser
                type={customerSearchType}
                placeholder={t(filterSlugs.placeholderSlug)}
                onSelect={(_value, item) => {
                  this.handleCustomerSelected(item);
                }}
                onRemove={(item) => {
                  this.handleCustomerRemoved(item);
                }}
                selectedItems={this.state.customers}
              />
            </>
          )}
        </Translation>
      </div>
    );
  }
}
